module.exports = __webpack_public_path__ + "img/farewell_8.eec6d337.jpg";